import messages from './messages'
import auth from './auth'
import profile from './profile'
import opportunity from './opportunity'
import location from './location'
import asset from './asset'
import validate from './validate'
import itineraryTemplate from './itinerary-template'
import { saveStatePlugin } from '@/helpers'

const isDevelopment = (
  process.env.NODE_ENV !== 'production' &&
  process.env.NODE_ENV !== 'dev' &&
  process.env.NODE_ENV !== 'pre'
)

const strict = isDevelopment

const state = {
  isDevelopment,
  appVersion: process.env.PACKAGE_VERSION || '0'
}

const modules = {
  messages,
  auth,
  profile,
  opportunity,
  location,
  asset,
  validate,
  itineraryTemplate
}

export default {
  strict,
  plugins: [ saveStatePlugin ],
  state,
  modules
}
